import { type SuretyAccountId } from "@inrev/common";
import { accountAttachmentsQueryKey } from "../account/account.keys";
import {
	balanceSheetsQueryKey,
	financialExtractionsQueryKey,
	financialPeriodsQueryKey,
	incomeStatementsQueryKey,
} from "../financials";
import { type AttachmentActionsConfig, useAttachmentActions } from "./useAttachmentActions";

type UseAccountAttachmentActionsConfig = {
	accountId: SuretyAccountId;
	isAdmin: boolean;
	allowDelete?: boolean;
	allowUpload?: boolean;
	allowTypeConfirmation?: boolean;
};

export function useAccountAttachmentActions({
	accountId,
	isAdmin,
	allowDelete,
	allowUpload,
	allowTypeConfirmation,
}: UseAccountAttachmentActionsConfig): AttachmentActionsConfig {
	const baseUrl = `/v2/${isAdmin ? "admin/" : ""}surety/accounts/${accountId}/attachments`;

	const invalidateQueryKeys = [
		accountAttachmentsQueryKey(accountId),
		financialPeriodsQueryKey(accountId),
		balanceSheetsQueryKey(accountId),
		incomeStatementsQueryKey(accountId),
		financialExtractionsQueryKey(accountId),
	];

	return useAttachmentActions({
		uploadUrl: baseUrl,
		downloadBaseUrl: baseUrl,
		downloadQueryKeyPrefix: isAdmin ? "adminAccountAttachments" : "accountAttachments",
		invalidateQueryKeys,
		allowDelete: allowDelete ?? isAdmin,
		allowUpload: allowUpload ?? true,
		allowTypeConfirmation: allowTypeConfirmation ?? isAdmin,
	});
}
